var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIconDarkGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0875 8.0625L15.9375 11.9125L9.1125 18.7375C8.9375 18.9125 8.7625 19 8.5 19H5.875C5.35 19 5 18.65 5 18.125V15.5C5 15.2375 5.0875 15.0625 5.2625 14.8875L12.0875 8.0625ZM18.7375 7.8875C19.0875 8.2375 19.0875 8.7625 18.7375 9.1125L17.1625 10.6875L13.3125 6.8375L14.8875 5.2625C15.2375 4.9125 15.7625 4.9125 16.1125 5.2625L18.7375 7.8875Z",
    fill: "#717171"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconDarkGray);
export default __webpack_public_path__ + "static/media/edit-icon-dark-gray.e64a37792b6cacf1a7241019ebf597b3.svg";
export { ForwardRef as ReactComponent };